const _ProductWaiverPremiums = {
  MMDirectTerm: {
    female: {
      'R+': {
        no: [
          { '10': '0.14616', '20': '0.18792' },
          { '10': '0.14616', '20': '0.19835999999999998' },
          { '10': '0.1566', '20': '0.19835999999999998' },
          { '10': '0.1566', '20': '0.19835999999999998' },
          { '10': '0.1566', '20': '0.19835999999999998' },
          { '10': '0.1566', '20': '0.19835999999999998' },
          { '10': '0.1566', '20': '0.19835999999999998' },
          { '10': '0.1566', '20': '0.19835999999999998' },
          { '10': '0.1566', '20': '0.19835999999999998' },
          { '10': '0.1566', '20': '0.20879999999999999' },
          { '10': '0.16704', '20': '0.20879999999999999' },
          { '10': '0.16704', '20': '0.21924000000000002' },
          { '10': '0.16704', '20': '0.21924000000000002' },
          { '10': '0.16704', '20': '0.21924000000000002' },
          { '10': '0.16704', '20': '0.21924000000000002' },
          { '10': '0.16704', '20': '0.21924000000000002' },
          { '10': '0.16704', '20': '0.21924000000000002' },
          { '10': '0.16704', '20': '0.21924000000000002' },
          { '10': '0.16704', '20': '0.22967999999999997' },
          { '10': '0.17748', '20': '0.261' },
          { '10': '0.20879999999999999', '20': '0.29232' },
          { '10': '0.25056', '20': '0.34452' },
          { '10': '0.261', '20': '0.37583999999999995' },
          { '10': '0.29232', '20': '0.40716' },
          { '10': '0.32364', '20': '0.45935999999999994' },
          { '10': '0.3654', '20': '0.5115599999999999' },
          { '10': '0.38627999999999996', '20': '0.55332' },
          { '10': '0.43848', '20': '0.6264' },
          { '10': '0.522', '20': '0.7412399999999999' },
          { '10': '0.6264', '20': '0.87696' },
          { '10': '0.7307999999999999', '20': '1.01268' },
          { '10': '0.8351999999999999', '20': '1.12752' },
          { '10': '0.9917999999999998', '20': '1.3049999999999997' },
          { '10': '1.07532', '20': '1.4094' },
          { '10': '1.1484', '20': '1.5242399999999998' },
          { '10': '1.2423599999999997', '20': '1.6703999999999999' },
          { '10': '1.37808', '20': '1.8374399999999997' },
          { '10': '1.5868799999999998', '20': '2.0358' },
          { '10': '1.75392', '20': '2.21328' },
          { '10': '1.9314', '20': '2.41164' },
          { '10': '2.1401999999999997', '20': '2.5578000000000003' },
          { '10': '2.3698799999999993', '20': '2.7248399999999995' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
        yes: [
          { '10': '0.1566', '20': '0.19835999999999998' },
          { '10': '0.1566', '20': '0.19835999999999998' },
          { '10': '0.1566', '20': '0.20879999999999999' },
          { '10': '0.1566', '20': '0.22967999999999997' },
          { '10': '0.1566', '20': '0.24012' },
          { '10': '0.1566', '20': '0.24012' },
          { '10': '0.1566', '20': '0.25056' },
          { '10': '0.1566', '20': '0.27143999999999996' },
          { '10': '0.1566', '20': '0.28188' },
          { '10': '0.16704', '20': '0.3027599999999999' },
          { '10': '0.17748', '20': '0.3132' },
          { '10': '0.19835999999999998', '20': '0.32364' },
          { '10': '0.19835999999999998', '20': '0.34452' },
          { '10': '0.20879999999999999', '20': '0.35496' },
          { '10': '0.20879999999999999', '20': '0.38627999999999996' },
          { '10': '0.21924', '20': '0.39671999999999996' },
          { '10': '0.24012', '20': '0.4280399999999999' },
          { '10': '0.25056', '20': '0.44892' },
          { '10': '0.27143999999999996', '20': '0.49067999999999995' },
          { '10': '0.28188', '20': '0.5115599999999999' },
          { '10': '0.3027599999999999', '20': '0.5428799999999999' },
          { '10': '0.33408', '20': '0.58464' },
          { '10': '0.39671999999999996', '20': '0.6264' },
          { '10': '0.4698', '20': '0.66816' },
          { '10': '0.5742', '20': '0.70992' },
          { '10': '0.65772', '20': '0.783' },
          { '10': '0.7307999999999999', '20': '0.8351999999999999' },
          { '10': '0.8247599999999999', '20': '0.90828' },
          { '10': '0.89784', '20': '0.9917999999999998' },
          { '10': '1.01268', '20': '1.10664' },
          { '10': '1.2110399999999997', '20': '1.2110399999999997' },
          { '10': '1.31544', '20': '1.31544' },
          { '10': '1.4720399999999998', '20': '1.4720399999999998' },
          { '10': '1.5868799999999998', '20': '1.5868799999999998' },
          { '10': '1.73304', '20': '1.73304' },
          { '10': '1.8792', '20': '1.8792' },
          { '10': '2.06712', '20': '2.06712' },
          { '10': '2.2654799999999997', '20': '2.2654799999999997' },
          { '10': '2.4325200000000002', '20': '2.4325200000000002' },
          { '10': '2.63088', '20': '2.63088' },
          { '10': '2.79792', '20': '2.79792' },
          { '10': '2.9754', '20': '2.9754' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
      },
      'Pf': {
        no: [
          { '10': '0.10439999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.13571999999999998' },
          { '10': '0.10439999999999999', '20': '0.13571999999999998' },
          { '10': '0.10439999999999999', '20': '0.13571999999999998' },
          { '10': '0.10439999999999999', '20': '0.13571999999999998' },
          { '10': '0.10439999999999999', '20': '0.14616' },
          { '10': '0.10439999999999999', '20': '0.14616' },
          { '10': '0.10439999999999999', '20': '0.14616' },
          { '10': '0.11483999999999998', '20': '0.14616' },
          { '10': '0.13571999999999998', '20': '0.15660000000000002' },
          { '10': '0.13571999999999998', '20': '0.17748' },
          { '10': '0.15660000000000002', '20': '0.18792' },
          { '10': '0.16704', '20': '0.21924000000000002' },
          { '10': '0.18792', '20': '0.25056' },
          { '10': '0.20879999999999999', '20': '0.28188' },
          { '10': '0.22967999999999997', '20': '0.33408' },
          { '10': '0.261', '20': '0.34452' },
          { '10': '0.28188', '20': '0.40716' },
          { '10': '0.34452', '20': '0.43848' },
          { '10': '0.41759999999999997', '20': '0.53244' },
          { '10': '0.50112', '20': '0.6055199999999998' },
          { '10': '0.61596', '20': '0.6368399999999999' },
          { '10': '0.70992', '20': '0.7307999999999999' },
          { '10': '0.783', '20': '0.8247599999999999' },
          { '10': '0.8873999999999999', '20': '0.92916' },
          { '10': '0.9917999999999998', '20': '1.03356' },
          { '10': '1.10664', '20': '1.15884' },
          { '10': '1.23192', '20': '1.2736799999999997' },
          { '10': '1.33632', '20': '1.37808' },
          { '10': '1.4511599999999998', '20': '1.5137999999999998' },
          { '10': '1.5764399999999998', '20': '1.6390799999999999' },
          { '10': '1.70172', '20': '1.7747999999999997' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
        yes: [
          { '10': '0.14616', '20': '0.19835999999999998' },
          { '10': '0.14616', '20': '0.19835999999999998' },
          { '10': '0.1566', '20': '0.20879999999999999' },
          { '10': '0.1566', '20': '0.20879999999999999' },
          { '10': '0.1566', '20': '0.22967999999999997' },
          { '10': '0.1566', '20': '0.24012' },
          { '10': '0.1566', '20': '0.25056' },
          { '10': '0.1566', '20': '0.25056' },
          { '10': '0.1566', '20': '0.27143999999999996' },
          { '10': '0.1566', '20': '0.28188' },
          { '10': '0.16704', '20': '0.3027599999999999' },
          { '10': '0.17748', '20': '0.3132' },
          { '10': '0.17748', '20': '0.32364' },
          { '10': '0.18791999999999998', '20': '0.34452' },
          { '10': '0.19835999999999998', '20': '0.36539999999999995' },
          { '10': '0.20879999999999999', '20': '0.38627999999999996' },
          { '10': '0.21924', '20': '0.40716' },
          { '10': '0.21924', '20': '0.40716' },
          { '10': '0.22967999999999997', '20': '0.41759999999999997' },
          { '10': '0.24012', '20': '0.43848' },
          { '10': '0.25056', '20': '0.45935999999999994' },
          { '10': '0.3027599999999999', '20': '0.53244' },
          { '10': '0.36539999999999995', '20': '0.58464' },
          { '10': '0.4280399999999999', '20': '0.6368399999999999' },
          { '10': '0.50112', '20': '0.6786' },
          { '10': '0.55332', '20': '0.7412399999999999' },
          { '10': '0.61596', '20': '0.8038799999999999' },
          { '10': '0.6786', '20': '0.87696' },
          { '10': '0.7412399999999999', '20': '0.9396' },
          { '10': '0.8247599999999999', '20': '1.044' },
          { '10': '0.9917999999999998', '20': '1.12752' },
          { '10': '1.15884', '20': '1.2423599999999997' },
          { '10': '1.2736799999999997', '20': '1.36764' },
          { '10': '1.37808', '20': '1.4929199999999998' },
          { '10': '1.4720399999999998', '20': '1.6390799999999999' },
          { '10': '1.59732', '20': '1.78524' },
          { '10': '1.7434799999999997', '20': '1.95228' },
          { '10': '1.9000799999999998', '20': '2.1401999999999997' },
          { '10': '2.088', '20': '2.31768' },
          { '10': '2.30724', '20': '2.5056' },
          { '10': '2.5578000000000003', '20': '2.6621999999999995' },
          { '10': '2.8292399999999995', '20': '2.8292399999999995' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
      },
      'P+': {
        no: [
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.13571999999999998' },
          { '10': '0.10439999999999999', '20': '0.14616' },
          { '10': '0.11483999999999998', '20': '0.16704' },
          { '10': '0.13571999999999998', '20': '0.17748' },
          { '10': '0.15660000000000002', '20': '0.19835999999999998' },
          { '10': '0.16704', '20': '0.22967999999999997' },
          { '10': '0.18792', '20': '0.28188' },
          { '10': '0.20879999999999999', '20': '0.30276000000000003' },
          { '10': '0.22967999999999997', '20': '0.34452' },
          { '10': '0.27143999999999996', '20': '0.38627999999999996' },
          { '10': '0.32364', '20': '0.44892' },
          { '10': '0.39671999999999996', '20': '0.5115599999999999' },
          { '10': '0.48024', '20': '0.56376' },
          { '10': '0.59508', '20': '0.64728' },
          { '10': '0.66816', '20': '0.72036' },
          { '10': '0.7621199999999999', '20': '0.7934399999999999' },
          { '10': '0.8456400000000001', '20': '0.8873999999999999' },
          { '10': '0.9500399999999999', '20': '0.9917999999999998' },
          { '10': '1.06488', '20': '1.1170799999999999' },
          { '10': '1.1484', '20': '1.2110399999999997' },
          { '10': '1.2423599999999997', '20': '1.31544' },
          { '10': '1.3572', '20': '1.43028' },
          { '10': '1.4511599999999998', '20': '1.5451199999999998' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
      },
    },
    male: {
      'R+': {
        no: [
          { '10': '0.09395999999999999', '20': '0.15660000000000002' },
          { '10': '0.09395999999999999', '20': '0.15660000000000002' },
          { '10': '0.10439999999999999', '20': '0.15660000000000002' },
          { '10': '0.10439999999999999', '20': '0.15660000000000002' },
          { '10': '0.10439999999999999', '20': '0.15660000000000002' },
          { '10': '0.10439999999999999', '20': '0.15660000000000002' },
          { '10': '0.10439999999999999', '20': '0.15660000000000002' },
          { '10': '0.10439999999999999', '20': '0.15660000000000002' },
          { '10': '0.10439999999999999', '20': '0.15660000000000002' },
          { '10': '0.10439999999999999', '20': '0.15660000000000002' },
          { '10': '0.11483999999999998', '20': '0.15660000000000002' },
          { '10': '0.11483999999999998', '20': '0.15660000000000002' },
          { '10': '0.13571999999999998', '20': '0.15660000000000002' },
          { '10': '0.13571999999999998', '20': '0.15660000000000002' },
          { '10': '0.13571999999999998', '20': '0.15660000000000002' },
          { '10': '0.13571999999999998', '20': '0.17748' },
          { '10': '0.13571999999999998', '20': '0.17748' },
          { '10': '0.13571999999999998', '20': '0.17748' },
          { '10': '0.13571999999999998', '20': '0.17748' },
          { '10': '0.13571999999999998', '20': '0.18792' },
          { '10': '0.15660000000000002', '20': '0.20879999999999999' },
          { '10': '0.17748', '20': '0.261' },
          { '10': '0.19835999999999998', '20': '0.28188' },
          { '10': '0.21924000000000002', '20': '0.3132' },
          { '10': '0.261', '20': '0.3654' },
          { '10': '0.29232', '20': '0.40716' },
          { '10': '0.3132', '20': '0.44892' },
          { '10': '0.37583999999999995', '20': '0.522' },
          { '10': '0.44892', '20': '0.6368399999999999' },
          { '10': '0.55332', '20': '0.783' },
          { '10': '0.65772', '20': '0.92916' },
          { '10': '0.7621199999999999', '20': '1.0857599999999998' },
          { '10': '0.90828', '20': '1.28412' },
          { '10': '0.9917999999999998', '20': '1.39896' },
          { '10': '1.0857599999999998', '20': '1.5137999999999998' },
          { '10': '1.2006', '20': '1.6703999999999999' },
          { '10': '1.3572', '20': '1.84788' },
          { '10': '1.5868799999999998', '20': '2.0462399999999996' },
          { '10': '1.75392', '20': '2.16108' },
          { '10': '1.9314', '20': '2.28636' },
          { '10': '2.1401999999999997', '20': '2.3907599999999998' },
          { '10': '2.3698799999999993', '20': '2.51604' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
        yes: [
          { '10': '0.12528', '20': '0.17748' },
          { '10': '0.12528', '20': '0.18791999999999998' },
          { '10': '0.12528', '20': '0.18791999999999998' },
          { '10': '0.12528', '20': '0.19835999999999998' },
          { '10': '0.12528', '20': '0.20879999999999999' },
          { '10': '0.12528', '20': '0.21924' },
          { '10': '0.12528', '20': '0.22967999999999997' },
          { '10': '0.13571999999999998', '20': '0.24012' },
          { '10': '0.13571999999999998', '20': '0.25056' },
          { '10': '0.14616', '20': '0.261' },
          { '10': '0.14616', '20': '0.27143999999999996' },
          { '10': '0.1566', '20': '0.28188' },
          { '10': '0.17748', '20': '0.3027599999999999' },
          { '10': '0.17748', '20': '0.3132' },
          { '10': '0.18791999999999998', '20': '0.33408' },
          { '10': '0.19835999999999998', '20': '0.35496' },
          { '10': '0.20879999999999999', '20': '0.37583999999999995' },
          { '10': '0.20879999999999999', '20': '0.37583999999999995' },
          { '10': '0.20879999999999999', '20': '0.37583999999999995' },
          { '10': '0.20879999999999999', '20': '0.38627999999999996' },
          { '10': '0.21924', '20': '0.40716' },
          { '10': '0.27143999999999996', '20': '0.49067999999999995' },
          { '10': '0.3132', '20': '0.5742' },
          { '10': '0.38627999999999996', '20': '0.6368399999999999' },
          { '10': '0.44892', '20': '0.69948' },
          { '10': '0.522', '20': '0.7725599999999999' },
          { '10': '0.5950799999999999', '20': '0.8351999999999999' },
          { '10': '0.68904', '20': '0.90828' },
          { '10': '0.7621199999999999', '20': '0.9917999999999998' },
          { '10': '0.87696', '20': '1.10664' },
          { '10': '1.07532', '20': '1.2110399999999997' },
          { '10': '1.2736799999999997', '20': '1.31544' },
          { '10': '1.4511599999999998', '20': '1.4720399999999998' },
          { '10': '1.5868799999999998', '20': '1.5868799999999998' },
          { '10': '1.73304', '20': '1.73304' },
          { '10': '1.8792', '20': '1.8792' },
          { '10': '2.06712', '20': '2.06712' },
          { '10': '2.2654799999999997', '20': '2.2654799999999997' },
          { '10': '2.4325200000000002', '20': '2.4325200000000002' },
          { '10': '2.63088', '20': '2.63088' },
          { '10': '2.79792', '20': '2.79792' },
          { '10': '2.9754', '20': '2.9754' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
      },
      'Pf': {
        no: [
          { '10': '0.07307999999999999', '20': '0.09395999999999999' },
          { '10': '0.07307999999999999', '20': '0.09395999999999999' },
          { '10': '0.07307999999999999', '20': '0.09395999999999999' },
          { '10': '0.07307999999999999', '20': '0.09395999999999999' },
          { '10': '0.07307999999999999', '20': '0.09395999999999999' },
          { '10': '0.07307999999999999', '20': '0.09395999999999999' },
          { '10': '0.07307999999999999', '20': '0.09395999999999999' },
          { '10': '0.07307999999999999', '20': '0.09395999999999999' },
          { '10': '0.07307999999999999', '20': '0.09395999999999999' },
          { '10': '0.07307999999999999', '20': '0.09395999999999999' },
          { '10': '0.07307999999999999', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.10439999999999999' },
          { '10': '0.08352', '20': '0.10439999999999999' },
          { '10': '0.08352', '20': '0.10439999999999999' },
          { '10': '0.08352', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.13571999999999998' },
          { '10': '0.13571999999999998', '20': '0.14616' },
          { '10': '0.13571999999999998', '20': '0.16704' },
          { '10': '0.15660000000000002', '20': '0.18792' },
          { '10': '0.16704', '20': '0.21924000000000002' },
          { '10': '0.19835999999999998', '20': '0.27143999999999996' },
          { '10': '0.20879999999999999', '20': '0.29232' },
          { '10': '0.22967999999999997', '20': '0.33408' },
          { '10': '0.29232', '20': '0.38627999999999996' },
          { '10': '0.3654', '20': '0.48024' },
          { '10': '0.43848', '20': '0.55332' },
          { '10': '0.5428799999999999', '20': '0.61596' },
          { '10': '0.66816', '20': '0.7203599999999999' },
          { '10': '0.783', '20': '0.81432' },
          { '10': '0.8873999999999999', '20': '0.90828' },
          { '10': '0.97092', '20': '0.9917999999999998' },
          { '10': '1.0857599999999998', '20': '1.10664' },
          { '10': '1.23192', '20': '1.23192' },
          { '10': '1.33632', '20': '1.3572' },
          { '10': '1.4511599999999998', '20': '1.4929199999999998' },
          { '10': '1.5764399999999998', '20': '1.6390799999999999' },
          { '10': '1.70172', '20': '1.79568' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
        yes: [
          { '10': '0.09395999999999999', '20': '0.17748' },
          { '10': '0.09395999999999999', '20': '0.17748' },
          { '10': '0.10439999999999999', '20': '0.18791999999999998' },
          { '10': '0.10439999999999999', '20': '0.19835999999999998' },
          { '10': '0.10439999999999999', '20': '0.19835999999999998' },
          { '10': '0.11483999999999998', '20': '0.20879999999999999' },
          { '10': '0.12528', '20': '0.21924' },
          { '10': '0.12528', '20': '0.22967999999999997' },
          { '10': '0.13571999999999998', '20': '0.24012' },
          { '10': '0.13571999999999998', '20': '0.25056' },
          { '10': '0.14616', '20': '0.261' },
          { '10': '0.14616', '20': '0.27143999999999996' },
          { '10': '0.1566', '20': '0.28188' },
          { '10': '0.1566', '20': '0.29232' },
          { '10': '0.1566', '20': '0.29232' },
          { '10': '0.17748', '20': '0.3132' },
          { '10': '0.17748', '20': '0.3132' },
          { '10': '0.17748', '20': '0.3132' },
          { '10': '0.17748', '20': '0.3132' },
          { '10': '0.17748', '20': '0.3132' },
          { '10': '0.18791999999999998', '20': '0.33408' },
          { '10': '0.22967999999999997', '20': '0.39671999999999996' },
          { '10': '0.28188', '20': '0.4698' },
          { '10': '0.33408', '20': '0.55332' },
          { '10': '0.38627999999999996', '20': '0.65772' },
          { '10': '0.43848', '20': '0.7412399999999999' },
          { '10': '0.50112', '20': '0.8038799999999999' },
          { '10': '0.56376', '20': '0.87696' },
          { '10': '0.6264', '20': '0.9396' },
          { '10': '0.70992', '20': '1.044' },
          { '10': '0.86652', '20': '1.12752' },
          { '10': '1.03356', '20': '1.2423599999999997' },
          { '10': '1.15884', '20': '1.36764' },
          { '10': '1.2736799999999997', '20': '1.4929199999999998' },
          { '10': '1.38852', '20': '1.6390799999999999' },
          { '10': '1.5346799999999998', '20': '1.78524' },
          { '10': '1.7121599999999997', '20': '1.95228' },
          { '10': '1.9000799999999998', '20': '2.1401999999999997' },
          { '10': '2.088', '20': '2.31768' },
          { '10': '2.30724', '20': '2.5056' },
          { '10': '2.5578000000000003', '20': '2.6621999999999995' },
          { '10': '2.8292399999999995', '20': '2.8292399999999995' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
      },
      'P+': {
        no: [
          { '10': '0.06264', '20': '0.07307999999999999' },
          { '10': '0.06264', '20': '0.07307999999999999' },
          { '10': '0.06264', '20': '0.07307999999999999' },
          { '10': '0.06264', '20': '0.07307999999999999' },
          { '10': '0.06264', '20': '0.07307999999999999' },
          { '10': '0.06264', '20': '0.07307999999999999' },
          { '10': '0.06264', '20': '0.07307999999999999' },
          { '10': '0.06264', '20': '0.07307999999999999' },
          { '10': '0.06264', '20': '0.07307999999999999' },
          { '10': '0.06264', '20': '0.07307999999999999' },
          { '10': '0.06264', '20': '0.07307999999999999' },
          { '10': '0.06264', '20': '0.08352' },
          { '10': '0.06264', '20': '0.08352' },
          { '10': '0.06264', '20': '0.08352' },
          { '10': '0.06264', '20': '0.08352' },
          { '10': '0.07307999999999999', '20': '0.08352' },
          { '10': '0.07307999999999999', '20': '0.08352' },
          { '10': '0.07307999999999999', '20': '0.08352' },
          { '10': '0.07307999999999999', '20': '0.08352' },
          { '10': '0.08352', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.13571999999999998' },
          { '10': '0.13571999999999998', '20': '0.15660000000000002' },
          { '10': '0.14616', '20': '0.18792' },
          { '10': '0.16704', '20': '0.21924000000000002' },
          { '10': '0.18792', '20': '0.25056' },
          { '10': '0.20879999999999999', '20': '0.29232' },
          { '10': '0.22967999999999997', '20': '0.32364' },
          { '10': '0.28188', '20': '0.40716' },
          { '10': '0.34452', '20': '0.48024' },
          { '10': '0.42804', '20': '0.5428799999999999' },
          { '10': '0.53244', '20': '0.64728' },
          { '10': '0.6264', '20': '0.72036' },
          { '10': '0.69948', '20': '0.7934399999999999' },
          { '10': '0.8038799999999999', '20': '0.8873999999999999' },
          { '10': '0.92916', '20': '0.9917999999999998' },
          { '10': '1.044', '20': '1.1170799999999999' },
          { '10': '1.12752', '20': '1.2110399999999997' },
          { '10': '1.2110399999999997', '20': '1.31544' },
          { '10': '1.31544', '20': '1.43028' },
          { '10': '1.41984', '20': '1.5451199999999998' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
      },
    },
    unisex: {
      'R+': {
        no: [
          { '10': '0.10439999999999999', '20': '0.16704' },
          { '10': '0.10439999999999999', '20': '0.16704' },
          { '10': '0.11483999999999998', '20': '0.16704' },
          { '10': '0.11483999999999998', '20': '0.16704' },
          { '10': '0.11483999999999998', '20': '0.16704' },
          { '10': '0.11483999999999998', '20': '0.16704' },
          { '10': '0.11483999999999998', '20': '0.16704' },
          { '10': '0.11483999999999998', '20': '0.16704' },
          { '10': '0.11483999999999998', '20': '0.16704' },
          { '10': '0.11483999999999998', '20': '0.16704' },
          { '10': '0.12528', '20': '0.16704' },
          { '10': '0.12528', '20': '0.16704' },
          { '10': '0.14616', '20': '0.16704' },
          { '10': '0.14616', '20': '0.16704' },
          { '10': '0.14616', '20': '0.16704' },
          { '10': '0.14616', '20': '0.18791999999999998' },
          { '10': '0.14616', '20': '0.18791999999999998' },
          { '10': '0.14616', '20': '0.18791999999999998' },
          { '10': '0.14616', '20': '0.18791999999999998' },
          { '10': '0.14616', '20': '0.19835999999999998' },
          { '10': '0.16704', '20': '0.22967999999999997' },
          { '10': '0.18791999999999998', '20': '0.28188' },
          { '10': '0.20879999999999999', '20': '0.3027599999999999' },
          { '10': '0.22967999999999997', '20': '0.33408' },
          { '10': '0.27143999999999996', '20': '0.38627999999999996' },
          { '10': '0.3027599999999999', '20': '0.4280399999999999' },
          { '10': '0.32364', '20': '0.4698' },
          { '10': '0.38627999999999996', '20': '0.5428799999999999' },
          { '10': '0.45935999999999994', '20': '0.65772' },
          { '10': '0.56376', '20': '0.8038799999999999' },
          { '10': '0.66816', '20': '0.9500399999999999' },
          { '10': '0.7725599999999999', '20': '1.0962' },
          { '10': '0.92916', '20': '1.28412' },
          { '10': '1.01268', '20': '1.39896' },
          { '10': '1.0962', '20': '1.5137999999999998' },
          { '10': '1.2110399999999997', '20': '1.6703999999999999' },
          { '10': '1.3572', '20': '1.84788' },
          { '10': '1.5868799999999998', '20': '2.0462399999999996' },
          { '10': '1.75392', '20': '2.1715199999999997' },
          { '10': '1.9314', '20': '2.30724' },
          { '10': '2.1401999999999997', '20': '2.4220799999999993' },
          { '10': '2.36988', '20': '2.5578000000000003' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
        yes: [
          { '10': '0.13571999999999998', '20': '0.17748' },
          { '10': '0.13571999999999998', '20': '0.18791999999999998' },
          { '10': '0.13571999999999998', '20': '0.18791999999999998' },
          { '10': '0.13571999999999998', '20': '0.20879999999999999' },
          { '10': '0.13571999999999998', '20': '0.21924' },
          { '10': '0.13571999999999998', '20': '0.21924' },
          { '10': '0.13571999999999998', '20': '0.22967999999999997' },
          { '10': '0.13571999999999998', '20': '0.25056' },
          { '10': '0.13571999999999998', '20': '0.261' },
          { '10': '0.14616', '20': '0.27143999999999996' },
          { '10': '0.1566', '20': '0.28188' },
          { '10': '0.16704', '20': '0.29232' },
          { '10': '0.17748', '20': '0.3132' },
          { '10': '0.18791999999999998', '20': '0.32364' },
          { '10': '0.18791999999999998', '20': '0.34452' },
          { '10': '0.19835999999999998', '20': '0.36539999999999995' },
          { '10': '0.21924', '20': '0.38627999999999996' },
          { '10': '0.21924', '20': '0.38627999999999996' },
          { '10': '0.21924', '20': '0.39671999999999996' },
          { '10': '0.21924', '20': '0.40716' },
          { '10': '0.24012', '20': '0.43848' },
          { '10': '0.28188', '20': '0.5115599999999999' },
          { '10': '0.33408', '20': '0.58464' },
          { '10': '0.40716', '20': '0.64728' },
          { '10': '0.4698', '20': '0.69948' },
          { '10': '0.55332', '20': '0.7725599999999999' },
          { '10': '0.6264', '20': '0.8351999999999999' },
          { '10': '0.7203599999999999', '20': '0.90828' },
          { '10': '0.7934399999999999', '20': '0.9917999999999998' },
          { '10': '0.90828', '20': '1.10664' },
          { '10': '1.10664', '20': '1.2110399999999997' },
          { '10': '1.28412', '20': '1.31544' },
          { '10': '1.4511599999999998', '20': '1.4720399999999998' },
          { '10': '1.5868799999999998', '20': '1.5868799999999998' },
          { '10': '1.73304', '20': '1.73304' },
          { '10': '1.8792', '20': '1.8792' },
          { '10': '2.06712', '20': '2.06712' },
          { '10': '2.2654799999999997', '20': '2.2654799999999997' },
          { '10': '2.4325200000000002', '20': '2.4325200000000002' },
          { '10': '2.63088', '20': '2.63088' },
          { '10': '2.79792', '20': '2.79792' },
          { '10': '2.9754', '20': '2.9754' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
      },
      'Pf': {
        no: [
          { '10': '0.08352', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.11483999999999998' },
          { '10': '0.08352', '20': '0.11483999999999998' },
          { '10': '0.08352', '20': '0.11483999999999998' },
          { '10': '0.08352', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.12528' },
          { '10': '0.11483999999999998', '20': '0.14616' },
          { '10': '0.13571999999999998', '20': '0.1566' },
          { '10': '0.14616', '20': '0.17748' },
          { '10': '0.16704', '20': '0.19835999999999998' },
          { '10': '0.17748', '20': '0.22967999999999997' },
          { '10': '0.20879999999999999', '20': '0.28188' },
          { '10': '0.21924', '20': '0.3027599999999999' },
          { '10': '0.24012', '20': '0.34452' },
          { '10': '0.3027599999999999', '20': '0.39671999999999996' },
          { '10': '0.37583999999999995', '20': '0.49067999999999995' },
          { '10': '0.44892', '20': '0.56376' },
          { '10': '0.55332', '20': '0.61596' },
          { '10': '0.6786', '20': '0.7203599999999999' },
          { '10': '0.783', '20': '0.81432' },
          { '10': '0.8873999999999999', '20': '0.90828' },
          { '10': '0.97092', '20': '1.00224' },
          { '10': '1.0857599999999998', '20': '1.1170799999999999' },
          { '10': '1.23192', '20': '1.2423599999999997' },
          { '10': '1.33632', '20': '1.3572' },
          { '10': '1.4511599999999998', '20': '1.4929199999999998' },
          { '10': '1.5764399999999998', '20': '1.6390799999999999' },
          { '10': '1.70172', '20': '1.79568' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
        yes: [
          { '10': '0.10439999999999999', '20': '0.17748' },
          { '10': '0.10439999999999999', '20': '0.17748' },
          { '10': '0.11483999999999998', '20': '0.18791999999999998' },
          { '10': '0.11483999999999998', '20': '0.19835999999999998' },
          { '10': '0.11483999999999998', '20': '0.20879999999999999' },
          { '10': '0.12528', '20': '0.21924' },
          { '10': '0.13571999999999998', '20': '0.22967999999999997' },
          { '10': '0.13571999999999998', '20': '0.22967999999999997' },
          { '10': '0.13571999999999998', '20': '0.25056' },
          { '10': '0.13571999999999998', '20': '0.261' },
          { '10': '0.14616', '20': '0.27143999999999996' },
          { '10': '0.1566', '20': '0.28188' },
          { '10': '0.1566', '20': '0.29232' },
          { '10': '0.16704', '20': '0.3027599999999999' },
          { '10': '0.16704', '20': '0.3027599999999999' },
          { '10': '0.18791999999999998', '20': '0.32364' },
          { '10': '0.18791999999999998', '20': '0.33408' },
          { '10': '0.18791999999999998', '20': '0.33408' },
          { '10': '0.18791999999999998', '20': '0.33408' },
          { '10': '0.18791999999999998', '20': '0.33408' },
          { '10': '0.19835999999999998', '20': '0.35496' },
          { '10': '0.24012', '20': '0.4280399999999999' },
          { '10': '0.3027599999999999', '20': '0.49067999999999995' },
          { '10': '0.35496', '20': '0.5742' },
          { '10': '0.40716', '20': '0.65772' },
          { '10': '0.45935999999999994', '20': '0.7412399999999999' },
          { '10': '0.522', '20': '0.8038799999999999' },
          { '10': '0.58464', '20': '0.87696' },
          { '10': '0.64728', '20': '0.9396' },
          { '10': '0.7307999999999999', '20': '1.044' },
          { '10': '0.8873999999999999', '20': '1.12752' },
          { '10': '1.0544399999999998', '20': '1.2423599999999997' },
          { '10': '1.1797199999999997', '20': '1.36764' },
          { '10': '1.29456', '20': '1.4929199999999998' },
          { '10': '1.4094', '20': '1.6390799999999999' },
          { '10': '1.5451199999999998', '20': '1.78524' },
          { '10': '1.7226', '20': '1.95228' },
          { '10': '1.9000799999999998', '20': '2.1401999999999997' },
          { '10': '2.088', '20': '2.31768' },
          { '10': '2.30724', '20': '2.5056' },
          { '10': '2.5578000000000003', '20': '2.6621999999999995' },
          { '10': '2.8292399999999995', '20': '2.8292399999999995' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
      },
      'P+': {
        no: [
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.10439999999999999' },
          { '10': '0.08352', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.12528' },
          { '10': '0.11483999999999998', '20': '0.14616' },
          { '10': '0.13571999999999998', '20': '0.16704' },
          { '10': '0.14616', '20': '0.19835999999999998' },
          { '10': '0.16704', '20': '0.22967999999999997' },
          { '10': '0.18791999999999998', '20': '0.261' },
          { '10': '0.20879999999999999', '20': '0.3027599999999999' },
          { '10': '0.24012', '20': '0.33408' },
          { '10': '0.29232', '20': '0.41759999999999997' },
          { '10': '0.35496', '20': '0.49067999999999995' },
          { '10': '0.43848', '20': '0.5428799999999999' },
          { '10': '0.5428799999999999', '20': '0.64728' },
          { '10': '0.6368399999999999', '20': '0.7203599999999999' },
          { '10': '0.70992', '20': '0.7934399999999999' },
          { '10': '0.81432', '20': '0.8873999999999999' },
          { '10': '0.92916', '20': '0.9917999999999998' },
          { '10': '1.044', '20': '1.1170799999999999' },
          { '10': '1.12752', '20': '1.2110399999999997' },
          { '10': '1.2110399999999997', '20': '1.31544' },
          { '10': '1.31544', '20': '1.43028' },
          { '10': '1.43028', '20': '1.5451199999999998' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
      },
    },
  },
  CASTerm: {
    female: {
      'R+': {
        yes: [
          { '10': '0.1566', '20': '0.19835999999999998' },
          { '10': '0.1566', '20': '0.19835999999999998' },
          { '10': '0.1566', '20': '0.20879999999999999' },
          { '10': '0.1566', '20': '0.22967999999999997' },
          { '10': '0.1566', '20': '0.24012' },
          { '10': '0.1566', '20': '0.24012' },
          { '10': '0.1566', '20': '0.25056' },
          { '10': '0.1566', '20': '0.27143999999999996' },
          { '10': '0.1566', '20': '0.28188' },
          { '10': '0.16704', '20': '0.3027599999999999' },
          { '10': '0.17748', '20': '0.3132' },
          { '10': '0.19835999999999998', '20': '0.32364' },
          { '10': '0.19835999999999998', '20': '0.34452' },
          { '10': '0.20879999999999999', '20': '0.35496' },
          { '10': '0.20879999999999999', '20': '0.38627999999999996' },
          { '10': '0.21924', '20': '0.39671999999999996' },
          { '10': '0.24012', '20': '0.4280399999999999' },
          { '10': '0.25056', '20': '0.44892' },
          { '10': '0.27143999999999996', '20': '0.49067999999999995' },
          { '10': '0.28188', '20': '0.5115599999999999' },
          { '10': '0.3027599999999999', '20': '0.5428799999999999' },
          { '10': '0.33408', '20': '0.58464' },
          { '10': '0.39671999999999996', '20': '0.6264' },
          { '10': '0.4698', '20': '0.66816' },
          { '10': '0.5742', '20': '0.70992' },
          { '10': '0.65772', '20': '0.783' },
          { '10': '0.7307999999999999', '20': '0.8351999999999999' },
          { '10': '0.8247599999999999', '20': '0.90828' },
          { '10': '0.89784', '20': '0.9917999999999998' },
          { '10': '1.01268', '20': '1.10664' },
          { '10': '1.2110399999999997', '20': '1.2110399999999997' },
          { '10': '1.31544', '20': '1.31544' },
          { '10': '1.4720399999999998', '20': '1.4720399999999998' },
          { '10': '1.5868799999999998', '20': '1.5868799999999998' },
          { '10': '1.73304', '20': '1.73304' },
          { '10': '1.8792', '20': '1.8792' },
          { '10': '2.06712', '20': '2.06712' },
          { '10': '2.2654799999999997', '20': '2.2654799999999997' },
          { '10': '2.4325200000000002', '20': '2.4325200000000002' },
          { '10': '2.63088', '20': '2.63088' },
          { '10': '2.79792', '20': '2.79792' },
          { '10': '2.9754', '20': '2.9754' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
        no: [
          { '10': '0.14616', '20': '0.18791999999999998' },
          { '10': '0.14616', '20': '0.19835999999999998' },
          { '10': '0.1566', '20': '0.19835999999999998' },
          { '10': '0.1566', '20': '0.19835999999999998' },
          { '10': '0.1566', '20': '0.19835999999999998' },
          { '10': '0.1566', '20': '0.19835999999999998' },
          { '10': '0.1566', '20': '0.19835999999999998' },
          { '10': '0.1566', '20': '0.19835999999999998' },
          { '10': '0.1566', '20': '0.19835999999999998' },
          { '10': '0.1566', '20': '0.20879999999999999' },
          { '10': '0.16704', '20': '0.20879999999999999' },
          { '10': '0.16704', '20': '0.21924' },
          { '10': '0.16704', '20': '0.21924' },
          { '10': '0.16704', '20': '0.21924' },
          { '10': '0.16704', '20': '0.21924' },
          { '10': '0.16704', '20': '0.21924' },
          { '10': '0.16704', '20': '0.21924' },
          { '10': '0.16704', '20': '0.21924' },
          { '10': '0.16704', '20': '0.22967999999999997' },
          { '10': '0.17748', '20': '0.261' },
          { '10': '0.20879999999999999', '20': '0.29232' },
          { '10': '0.25056', '20': '0.34452' },
          { '10': '0.261', '20': '0.37583999999999995' },
          { '10': '0.29232', '20': '0.40716' },
          { '10': '0.32364', '20': '0.45935999999999994' },
          { '10': '0.36539999999999995', '20': '0.5115599999999999' },
          { '10': '0.38627999999999996', '20': '0.55332' },
          { '10': '0.43848', '20': '0.6264' },
          { '10': '0.522', '20': '0.7412399999999999' },
          { '10': '0.6264', '20': '0.87696' },
          { '10': '0.7307999999999999', '20': '1.01268' },
          { '10': '0.8351999999999999', '20': '1.12752' },
          { '10': '0.9917999999999998', '20': '1.3049999999999997' },
          { '10': '1.07532', '20': '1.4094' },
          { '10': '1.1484', '20': '1.5242399999999998' },
          { '10': '1.2423599999999997', '20': '1.6703999999999999' },
          { '10': '1.37808', '20': '1.8374399999999997' },
          { '10': '1.5868799999999998', '20': '2.0358' },
          { '10': '1.75392', '20': '2.21328' },
          { '10': '1.9314', '20': '2.41164' },
          { '10': '2.1401999999999997', '20': '2.5578000000000003' },
          { '10': '2.36988', '20': '2.7248399999999995' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
      },
      'Pf': {
        yes: [
          { '10': '0.14616', '20': '0.19835999999999998' },
          { '10': '0.14616', '20': '0.19835999999999998' },
          { '10': '0.1566', '20': '0.20879999999999999' },
          { '10': '0.1566', '20': '0.20879999999999999' },
          { '10': '0.1566', '20': '0.22967999999999997' },
          { '10': '0.1566', '20': '0.24012' },
          { '10': '0.1566', '20': '0.25056' },
          { '10': '0.1566', '20': '0.25056' },
          { '10': '0.1566', '20': '0.27143999999999996' },
          { '10': '0.1566', '20': '0.28188' },
          { '10': '0.16704', '20': '0.3027599999999999' },
          { '10': '0.17748', '20': '0.3132' },
          { '10': '0.17748', '20': '0.32364' },
          { '10': '0.18791999999999998', '20': '0.34452' },
          { '10': '0.19835999999999998', '20': '0.36539999999999995' },
          { '10': '0.20879999999999999', '20': '0.38627999999999996' },
          { '10': '0.21924', '20': '0.40716' },
          { '10': '0.21924', '20': '0.40716' },
          { '10': '0.22967999999999997', '20': '0.41759999999999997' },
          { '10': '0.24012', '20': '0.43848' },
          { '10': '0.25056', '20': '0.45935999999999994' },
          { '10': '0.3027599999999999', '20': '0.53244' },
          { '10': '0.36539999999999995', '20': '0.58464' },
          { '10': '0.4280399999999999', '20': '0.6368399999999999' },
          { '10': '0.50112', '20': '0.6786' },
          { '10': '0.55332', '20': '0.7412399999999999' },
          { '10': '0.61596', '20': '0.8038799999999999' },
          { '10': '0.6786', '20': '0.87696' },
          { '10': '0.7412399999999999', '20': '0.9396' },
          { '10': '0.8247599999999999', '20': '1.044' },
          { '10': '0.9917999999999998', '20': '1.12752' },
          { '10': '1.15884', '20': '1.2423599999999997' },
          { '10': '1.2736799999999997', '20': '1.36764' },
          { '10': '1.37808', '20': '1.4929199999999998' },
          { '10': '1.4720399999999998', '20': '1.6390799999999999' },
          { '10': '1.59732', '20': '1.78524' },
          { '10': '1.7434799999999997', '20': '1.95228' },
          { '10': '1.9000799999999998', '20': '2.1401999999999997' },
          { '10': '2.088', '20': '2.31768' },
          { '10': '2.30724', '20': '2.5056' },
          { '10': '2.5578000000000003', '20': '2.6621999999999995' },
          { '10': '2.8292399999999995', '20': '2.8292399999999995' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
        no: [
          { '10': '0.10439999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.13571999999999998' },
          { '10': '0.10439999999999999', '20': '0.13571999999999998' },
          { '10': '0.10439999999999999', '20': '0.13571999999999998' },
          { '10': '0.10439999999999999', '20': '0.13571999999999998' },
          { '10': '0.10439999999999999', '20': '0.14616' },
          { '10': '0.10439999999999999', '20': '0.14616' },
          { '10': '0.10439999999999999', '20': '0.14616' },
          { '10': '0.11483999999999998', '20': '0.14616' },
          { '10': '0.13571999999999998', '20': '0.1566' },
          { '10': '0.13571999999999998', '20': '0.17748' },
          { '10': '0.1566', '20': '0.18791999999999998' },
          { '10': '0.16704', '20': '0.21924' },
          { '10': '0.18791999999999998', '20': '0.25056' },
          { '10': '0.20879999999999999', '20': '0.28188' },
          { '10': '0.22967999999999997', '20': '0.33408' },
          { '10': '0.261', '20': '0.34452' },
          { '10': '0.28188', '20': '0.40716' },
          { '10': '0.34452', '20': '0.43848' },
          { '10': '0.41759999999999997', '20': '0.53244' },
          { '10': '0.50112', '20': '0.6055199999999998' },
          { '10': '0.61596', '20': '0.6368399999999999' },
          { '10': '0.70992', '20': '0.7307999999999999' },
          { '10': '0.783', '20': '0.8247599999999999' },
          { '10': '0.8873999999999999', '20': '0.92916' },
          { '10': '0.9917999999999998', '20': '1.03356' },
          { '10': '1.10664', '20': '1.15884' },
          { '10': '1.23192', '20': '1.2736799999999997' },
          { '10': '1.33632', '20': '1.37808' },
          { '10': '1.4511599999999998', '20': '1.5137999999999998' },
          { '10': '1.5764399999999998', '20': '1.6390799999999999' },
          { '10': '1.70172', '20': '1.7747999999999997' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
      },
      'P+': {
        no: [
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.13571999999999998' },
          { '10': '0.10439999999999999', '20': '0.14616' },
          { '10': '0.11483999999999998', '20': '0.16704' },
          { '10': '0.13571999999999998', '20': '0.17748' },
          { '10': '0.1566', '20': '0.19835999999999998' },
          { '10': '0.16704', '20': '0.22967999999999997' },
          { '10': '0.18791999999999998', '20': '0.28188' },
          { '10': '0.20879999999999999', '20': '0.3027599999999999' },
          { '10': '0.22967999999999997', '20': '0.34452' },
          { '10': '0.27143999999999996', '20': '0.38627999999999996' },
          { '10': '0.32364', '20': '0.44892' },
          { '10': '0.39671999999999996', '20': '0.5115599999999999' },
          { '10': '0.48024', '20': '0.56376' },
          { '10': '0.5950799999999999', '20': '0.64728' },
          { '10': '0.66816', '20': '0.7203599999999999' },
          { '10': '0.7621199999999999', '20': '0.7934399999999999' },
          { '10': '0.8456400000000001', '20': '0.8873999999999999' },
          { '10': '0.9500399999999999', '20': '0.9917999999999998' },
          { '10': '1.06488', '20': '1.1170799999999999' },
          { '10': '1.1484', '20': '1.2110399999999997' },
          { '10': '1.2423599999999997', '20': '1.31544' },
          { '10': '1.3572', '20': '1.43028' },
          { '10': '1.4511599999999998', '20': '1.5451199999999998' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
      },
    },
    male: {
      'R+': {
        no: [
          { '10': '0.09395999999999999', '20': '0.1566' },
          { '10': '0.09395999999999999', '20': '0.1566' },
          { '10': '0.10439999999999999', '20': '0.1566' },
          { '10': '0.10439999999999999', '20': '0.1566' },
          { '10': '0.10439999999999999', '20': '0.1566' },
          { '10': '0.10439999999999999', '20': '0.1566' },
          { '10': '0.10439999999999999', '20': '0.1566' },
          { '10': '0.10439999999999999', '20': '0.1566' },
          { '10': '0.10439999999999999', '20': '0.1566' },
          { '10': '0.10439999999999999', '20': '0.1566' },
          { '10': '0.11483999999999998', '20': '0.1566' },
          { '10': '0.11483999999999998', '20': '0.1566' },
          { '10': '0.13571999999999998', '20': '0.1566' },
          { '10': '0.13571999999999998', '20': '0.1566' },
          { '10': '0.13571999999999998', '20': '0.1566' },
          { '10': '0.13571999999999998', '20': '0.17748' },
          { '10': '0.13571999999999998', '20': '0.17748' },
          { '10': '0.13571999999999998', '20': '0.17748' },
          { '10': '0.13571999999999998', '20': '0.17748' },
          { '10': '0.13571999999999998', '20': '0.18791999999999998' },
          { '10': '0.1566', '20': '0.20879999999999999' },
          { '10': '0.17748', '20': '0.261' },
          { '10': '0.19835999999999998', '20': '0.28188' },
          { '10': '0.21924', '20': '0.3132' },
          { '10': '0.261', '20': '0.36539999999999995' },
          { '10': '0.29232', '20': '0.40716' },
          { '10': '0.3132', '20': '0.44892' },
          { '10': '0.37583999999999995', '20': '0.522' },
          { '10': '0.44892', '20': '0.6368399999999999' },
          { '10': '0.55332', '20': '0.783' },
          { '10': '0.65772', '20': '0.92916' },
          { '10': '0.7621199999999999', '20': '1.0857599999999998' },
          { '10': '0.90828', '20': '1.28412' },
          { '10': '0.9917999999999998', '20': '1.39896' },
          { '10': '1.0857599999999998', '20': '1.5137999999999998' },
          { '10': '1.2006', '20': '1.6703999999999999' },
          { '10': '1.3572', '20': '1.84788' },
          { '10': '1.5868799999999998', '20': '2.0462399999999996' },
          { '10': '1.75392', '20': '2.1610799999999997' },
          { '10': '1.9314', '20': '2.2863599999999997' },
          { '10': '2.1401999999999997', '20': '2.3907599999999998' },
          { '10': '2.36988', '20': '2.51604' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
        yes: [
          { '10': '0.12528', '20': '0.17748' },
          { '10': '0.12528', '20': '0.18791999999999998' },
          { '10': '0.12528', '20': '0.18791999999999998' },
          { '10': '0.12528', '20': '0.19835999999999998' },
          { '10': '0.12528', '20': '0.20879999999999999' },
          { '10': '0.12528', '20': '0.21924' },
          { '10': '0.12528', '20': '0.22967999999999997' },
          { '10': '0.13571999999999998', '20': '0.24012' },
          { '10': '0.13571999999999998', '20': '0.25056' },
          { '10': '0.14616', '20': '0.261' },
          { '10': '0.14616', '20': '0.27143999999999996' },
          { '10': '0.1566', '20': '0.28188' },
          { '10': '0.17748', '20': '0.3027599999999999' },
          { '10': '0.17748', '20': '0.3132' },
          { '10': '0.18791999999999998', '20': '0.33408' },
          { '10': '0.19835999999999998', '20': '0.35496' },
          { '10': '0.20879999999999999', '20': '0.37583999999999995' },
          { '10': '0.20879999999999999', '20': '0.37583999999999995' },
          { '10': '0.20879999999999999', '20': '0.37583999999999995' },
          { '10': '0.20879999999999999', '20': '0.38627999999999996' },
          { '10': '0.21924', '20': '0.40716' },
          { '10': '0.27143999999999996', '20': '0.49067999999999995' },
          { '10': '0.3132', '20': '0.5742' },
          { '10': '0.38627999999999996', '20': '0.6368399999999999' },
          { '10': '0.44892', '20': '0.69948' },
          { '10': '0.522', '20': '0.7725599999999999' },
          { '10': '0.5950799999999999', '20': '0.8351999999999999' },
          { '10': '0.68904', '20': '0.90828' },
          { '10': '0.7621199999999999', '20': '0.9917999999999998' },
          { '10': '0.87696', '20': '1.10664' },
          { '10': '1.07532', '20': '1.2110399999999997' },
          { '10': '1.2736799999999997', '20': '1.31544' },
          { '10': '1.4511599999999998', '20': '1.4720399999999998' },
          { '10': '1.5868799999999998', '20': '1.5868799999999998' },
          { '10': '1.73304', '20': '1.73304' },
          { '10': '1.8792', '20': '1.8792' },
          { '10': '2.06712', '20': '2.06712' },
          { '10': '2.2654799999999997', '20': '2.2654799999999997' },
          { '10': '2.4325200000000002', '20': '2.4325200000000002' },
          { '10': '2.63088', '20': '2.63088' },
          { '10': '2.79792', '20': '2.79792' },
          { '10': '2.9754', '20': '2.9754' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
      },
      'Pf': {
        no: [
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.10439999999999999' },
          { '10': '0.08352', '20': '0.10439999999999999' },
          { '10': '0.08352', '20': '0.10439999999999999' },
          { '10': '0.08352', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.13571999999999998' },
          { '10': '0.13571999999999998', '20': '0.14616' },
          { '10': '0.13571999999999998', '20': '0.16704' },
          { '10': '0.1566', '20': '0.18791999999999998' },
          { '10': '0.16704', '20': '0.21924' },
          { '10': '0.19835999999999998', '20': '0.27143999999999996' },
          { '10': '0.20879999999999999', '20': '0.29232' },
          { '10': '0.22967999999999997', '20': '0.33408' },
          { '10': '0.29232', '20': '0.38627999999999996' },
          { '10': '0.36539999999999995', '20': '0.48024' },
          { '10': '0.43848', '20': '0.55332' },
          { '10': '0.5428799999999999', '20': '0.61596' },
          { '10': '0.66816', '20': '0.7203599999999999' },
          { '10': '0.783', '20': '0.81432' },
          { '10': '0.8873999999999999', '20': '0.90828' },
          { '10': '0.97092', '20': '0.9917999999999998' },
          { '10': '1.0857599999999998', '20': '1.10664' },
          { '10': '1.23192', '20': '1.23192' },
          { '10': '1.33632', '20': '1.3572' },
          { '10': '1.4511599999999998', '20': '1.4929199999999998' },
          { '10': '1.5764399999999998', '20': '1.6390799999999999' },
          { '10': '1.70172', '20': '1.79568' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
        yes: [
          { '10': '0.09395999999999999', '20': '0.17748' },
          { '10': '0.09395999999999999', '20': '0.17748' },
          { '10': '0.10439999999999999', '20': '0.18791999999999998' },
          { '10': '0.10439999999999999', '20': '0.19835999999999998' },
          { '10': '0.10439999999999999', '20': '0.19835999999999998' },
          { '10': '0.11483999999999998', '20': '0.20879999999999999' },
          { '10': '0.12528', '20': '0.21924' },
          { '10': '0.12528', '20': '0.22967999999999997' },
          { '10': '0.13571999999999998', '20': '0.24012' },
          { '10': '0.13571999999999998', '20': '0.25056' },
          { '10': '0.14616', '20': '0.261' },
          { '10': '0.14616', '20': '0.27143999999999996' },
          { '10': '0.1566', '20': '0.28188' },
          { '10': '0.1566', '20': '0.29232' },
          { '10': '0.1566', '20': '0.29232' },
          { '10': '0.17748', '20': '0.3132' },
          { '10': '0.17748', '20': '0.3132' },
          { '10': '0.17748', '20': '0.3132' },
          { '10': '0.17748', '20': '0.3132' },
          { '10': '0.17748', '20': '0.3132' },
          { '10': '0.18791999999999998', '20': '0.33408' },
          { '10': '0.22967999999999997', '20': '0.39671999999999996' },
          { '10': '0.28188', '20': '0.4698' },
          { '10': '0.33408', '20': '0.55332' },
          { '10': '0.38627999999999996', '20': '0.65772' },
          { '10': '0.43848', '20': '0.7412399999999999' },
          { '10': '0.50112', '20': '0.8038799999999999' },
          { '10': '0.56376', '20': '0.87696' },
          { '10': '0.6264', '20': '0.9396' },
          { '10': '0.70992', '20': '1.044' },
          { '10': '0.86652', '20': '1.12752' },
          { '10': '1.03356', '20': '1.2423599999999997' },
          { '10': '1.15884', '20': '1.36764' },
          { '10': '1.2736799999999997', '20': '1.4929199999999998' },
          { '10': '1.38852', '20': '1.6390799999999999' },
          { '10': '1.5346799999999998', '20': '1.78524' },
          { '10': '1.7121599999999997', '20': '1.95228' },
          { '10': '1.9000799999999998', '20': '2.1401999999999997' },
          { '10': '2.088', '20': '2.31768' },
          { '10': '2.30724', '20': '2.5056' },
          { '10': '2.5578000000000003', '20': '2.6621999999999995' },
          { '10': '2.8292399999999995', '20': '2.8292399999999995' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
      },
      'P+': {
        no: [
          { '10': '0.06264', '20': '0.07308' },
          { '10': '0.06264', '20': '0.07308' },
          { '10': '0.06264', '20': '0.07308' },
          { '10': '0.06264', '20': '0.07308' },
          { '10': '0.06264', '20': '0.07308' },
          { '10': '0.06264', '20': '0.07308' },
          { '10': '0.06264', '20': '0.07308' },
          { '10': '0.06264', '20': '0.07308' },
          { '10': '0.06264', '20': '0.07308' },
          { '10': '0.06264', '20': '0.07308' },
          { '10': '0.06264', '20': '0.07308' },
          { '10': '0.06264', '20': '0.08352' },
          { '10': '0.06264', '20': '0.08352' },
          { '10': '0.06264', '20': '0.08352' },
          { '10': '0.06264', '20': '0.08352' },
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.08352', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.10439999999999999' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.13571999999999998' },
          { '10': '0.13571999999999998', '20': '0.1566' },
          { '10': '0.14616', '20': '0.18791999999999998' },
          { '10': '0.16704', '20': '0.21924' },
          { '10': '0.18791999999999998', '20': '0.25056' },
          { '10': '0.20879999999999999', '20': '0.29232' },
          { '10': '0.22967999999999997', '20': '0.32364' },
          { '10': '0.28188', '20': '0.40716' },
          { '10': '0.34452', '20': '0.48024' },
          { '10': '0.4280399999999999', '20': '0.5428799999999999' },
          { '10': '0.53244', '20': '0.64728' },
          { '10': '0.6264', '20': '0.7203599999999999' },
          { '10': '0.69948', '20': '0.7934399999999999' },
          { '10': '0.8038799999999999', '20': '0.8873999999999999' },
          { '10': '0.92916', '20': '0.9917999999999998' },
          { '10': '1.044', '20': '1.1170799999999999' },
          { '10': '1.12752', '20': '1.2110399999999997' },
          { '10': '1.2110399999999997', '20': '1.31544' },
          { '10': '1.31544', '20': '1.43028' },
          { '10': '1.41984', '20': '1.5451199999999998' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
      },
    },
    unisex: {
      'Pf': {
        no: [
          { '10': '0.08352', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.11483999999999998' },
          { '10': '0.08352', '20': '0.11483999999999998' },
          { '10': '0.08352', '20': '0.11483999999999998' },
          { '10': '0.08352', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.11483999999999998' },
          { '10': '0.10439999999999999', '20': '0.12528' },
          { '10': '0.11483999999999998', '20': '0.14616' },
          { '10': '0.13571999999999998', '20': '0.1566' },
          { '10': '0.14616', '20': '0.17748' },
          { '10': '0.16704', '20': '0.19835999999999998' },
          { '10': '0.17748', '20': '0.22967999999999997' },
          { '10': '0.20879999999999999', '20': '0.28188' },
          { '10': '0.21924', '20': '0.3027599999999999' },
          { '10': '0.24012', '20': '0.34452' },
          { '10': '0.3027599999999999', '20': '0.39671999999999996' },
          { '10': '0.37583999999999995', '20': '0.49067999999999995' },
          { '10': '0.44892', '20': '0.56376' },
          { '10': '0.55332', '20': '0.61596' },
          { '10': '0.6786', '20': '0.7203599999999999' },
          { '10': '0.783', '20': '0.81432' },
          { '10': '0.8873999999999999', '20': '0.90828' },
          { '10': '0.97092', '20': '1.00224' },
          { '10': '1.0857599999999998', '20': '1.1170799999999999' },
          { '10': '1.23192', '20': '1.2423599999999997' },
          { '10': '1.33632', '20': '1.3572' },
          { '10': '1.4511599999999998', '20': '1.4929199999999998' },
          { '10': '1.5764399999999998', '20': '1.6390799999999999' },
          { '10': '1.70172', '20': '1.79568' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
        yes: [
          { '10': '0.10439999999999999', '20': '0.17748' },
          { '10': '0.10439999999999999', '20': '0.17748' },
          { '10': '0.11483999999999998', '20': '0.18791999999999998' },
          { '10': '0.11483999999999998', '20': '0.19835999999999998' },
          { '10': '0.11483999999999998', '20': '0.20879999999999999' },
          { '10': '0.12528', '20': '0.21924' },
          { '10': '0.13571999999999998', '20': '0.22967999999999997' },
          { '10': '0.13571999999999998', '20': '0.22967999999999997' },
          { '10': '0.13571999999999998', '20': '0.25056' },
          { '10': '0.13571999999999998', '20': '0.261' },
          { '10': '0.14616', '20': '0.27143999999999996' },
          { '10': '0.1566', '20': '0.28188' },
          { '10': '0.1566', '20': '0.29232' },
          { '10': '0.16704', '20': '0.3027599999999999' },
          { '10': '0.16704', '20': '0.3027599999999999' },
          { '10': '0.18791999999999998', '20': '0.32364' },
          { '10': '0.18791999999999998', '20': '0.33408' },
          { '10': '0.18791999999999998', '20': '0.33408' },
          { '10': '0.18791999999999998', '20': '0.33408' },
          { '10': '0.18791999999999998', '20': '0.33408' },
          { '10': '0.19835999999999998', '20': '0.35496' },
          { '10': '0.24012', '20': '0.4280399999999999' },
          { '10': '0.3027599999999999', '20': '0.49067999999999995' },
          { '10': '0.35496', '20': '0.5742' },
          { '10': '0.40716', '20': '0.65772' },
          { '10': '0.45935999999999994', '20': '0.7412399999999999' },
          { '10': '0.522', '20': '0.8038799999999999' },
          { '10': '0.58464', '20': '0.87696' },
          { '10': '0.64728', '20': '0.9396' },
          { '10': '0.7307999999999999', '20': '1.044' },
          { '10': '0.8873999999999999', '20': '1.12752' },
          { '10': '1.0544399999999998', '20': '1.2423599999999997' },
          { '10': '1.1797199999999997', '20': '1.36764' },
          { '10': '1.29456', '20': '1.4929199999999998' },
          { '10': '1.4094', '20': '1.6390799999999999' },
          { '10': '1.5451199999999998', '20': '1.78524' },
          { '10': '1.7226', '20': '1.95228' },
          { '10': '1.9000799999999998', '20': '2.1401999999999997' },
          { '10': '2.088', '20': '2.31768' },
          { '10': '2.30724', '20': '2.5056' },
          { '10': '2.5578000000000003', '20': '2.6621999999999995' },
          { '10': '2.8292399999999995', '20': '2.8292399999999995' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
      },
      'R+': {
        no: [
          { '10': '0.10439999999999999', '20': '0.16704' },
          { '10': '0.10439999999999999', '20': '0.16704' },
          { '10': '0.11483999999999998', '20': '0.16704' },
          { '10': '0.11483999999999998', '20': '0.16704' },
          { '10': '0.11483999999999998', '20': '0.16704' },
          { '10': '0.11483999999999998', '20': '0.16704' },
          { '10': '0.11483999999999998', '20': '0.16704' },
          { '10': '0.11483999999999998', '20': '0.16704' },
          { '10': '0.11483999999999998', '20': '0.16704' },
          { '10': '0.11483999999999998', '20': '0.16704' },
          { '10': '0.12528', '20': '0.16704' },
          { '10': '0.12528', '20': '0.16704' },
          { '10': '0.14616', '20': '0.16704' },
          { '10': '0.14616', '20': '0.16704' },
          { '10': '0.14616', '20': '0.16704' },
          { '10': '0.14616', '20': '0.18791999999999998' },
          { '10': '0.14616', '20': '0.18791999999999998' },
          { '10': '0.14616', '20': '0.18791999999999998' },
          { '10': '0.14616', '20': '0.18791999999999998' },
          { '10': '0.14616', '20': '0.19835999999999998' },
          { '10': '0.16704', '20': '0.22967999999999997' },
          { '10': '0.18791999999999998', '20': '0.28188' },
          { '10': '0.20879999999999999', '20': '0.3027599999999999' },
          { '10': '0.22967999999999997', '20': '0.33408' },
          { '10': '0.27143999999999996', '20': '0.38627999999999996' },
          { '10': '0.3027599999999999', '20': '0.4280399999999999' },
          { '10': '0.32364', '20': '0.4698' },
          { '10': '0.38627999999999996', '20': '0.5428799999999999' },
          { '10': '0.45935999999999994', '20': '0.65772' },
          { '10': '0.56376', '20': '0.8038799999999999' },
          { '10': '0.66816', '20': '0.9500399999999999' },
          { '10': '0.7725599999999999', '20': '1.0962' },
          { '10': '0.92916', '20': '1.28412' },
          { '10': '1.01268', '20': '1.39896' },
          { '10': '1.0962', '20': '1.5137999999999998' },
          { '10': '1.2110399999999997', '20': '1.6703999999999999' },
          { '10': '1.3572', '20': '1.84788' },
          { '10': '1.5868799999999998', '20': '2.0462399999999996' },
          { '10': '1.75392', '20': '2.1715199999999997' },
          { '10': '1.9314', '20': '2.30724' },
          { '10': '2.1401999999999997', '20': '2.4220799999999993' },
          { '10': '2.36988', '20': '2.5578000000000003' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
        yes: [
          { '10': '0.13571999999999998', '20': '0.17748' },
          { '10': '0.13571999999999998', '20': '0.18791999999999998' },
          { '10': '0.13571999999999998', '20': '0.18791999999999998' },
          { '10': '0.13571999999999998', '20': '0.20879999999999999' },
          { '10': '0.13571999999999998', '20': '0.21924' },
          { '10': '0.13571999999999998', '20': '0.21924' },
          { '10': '0.13571999999999998', '20': '0.22967999999999997' },
          { '10': '0.13571999999999998', '20': '0.25056' },
          { '10': '0.13571999999999998', '20': '0.261' },
          { '10': '0.14616', '20': '0.27143999999999996' },
          { '10': '0.1566', '20': '0.28188' },
          { '10': '0.16704', '20': '0.29232' },
          { '10': '0.17748', '20': '0.3132' },
          { '10': '0.18791999999999998', '20': '0.32364' },
          { '10': '0.18791999999999998', '20': '0.34452' },
          { '10': '0.19835999999999998', '20': '0.36539999999999995' },
          { '10': '0.21924', '20': '0.38627999999999996' },
          { '10': '0.21924', '20': '0.38627999999999996' },
          { '10': '0.21924', '20': '0.39671999999999996' },
          { '10': '0.21924', '20': '0.40716' },
          { '10': '0.24012', '20': '0.43848' },
          { '10': '0.28188', '20': '0.5115599999999999' },
          { '10': '0.33408', '20': '0.58464' },
          { '10': '0.40716', '20': '0.64728' },
          { '10': '0.4698', '20': '0.69948' },
          { '10': '0.55332', '20': '0.7725599999999999' },
          { '10': '0.6264', '20': '0.8351999999999999' },
          { '10': '0.7203599999999999', '20': '0.90828' },
          { '10': '0.7934399999999999', '20': '0.9917999999999998' },
          { '10': '0.90828', '20': '1.10664' },
          { '10': '1.10664', '20': '1.2110399999999997' },
          { '10': '1.28412', '20': '1.31544' },
          { '10': '1.4511599999999998', '20': '1.4720399999999998' },
          { '10': '1.5868799999999998', '20': '1.5868799999999998' },
          { '10': '1.73304', '20': '1.73304' },
          { '10': '1.8792', '20': '1.8792' },
          { '10': '2.06712', '20': '2.06712' },
          { '10': '2.2654799999999997', '20': '2.2654799999999997' },
          { '10': '2.4325200000000002', '20': '2.4325200000000002' },
          { '10': '2.63088', '20': '2.63088' },
          { '10': '2.79792', '20': '2.79792' },
          { '10': '2.9754', '20': '2.9754' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
      },
      'P+': {
        no: [
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.08352' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.07308', '20': '0.09395999999999999' },
          { '10': '0.08352', '20': '0.10439999999999999' },
          { '10': '0.08352', '20': '0.11483999999999998' },
          { '10': '0.09395999999999999', '20': '0.12528' },
          { '10': '0.11483999999999998', '20': '0.14616' },
          { '10': '0.13571999999999998', '20': '0.16704' },
          { '10': '0.14616', '20': '0.19835999999999998' },
          { '10': '0.16704', '20': '0.22967999999999997' },
          { '10': '0.18791999999999998', '20': '0.261' },
          { '10': '0.20879999999999999', '20': '0.3027599999999999' },
          { '10': '0.24012', '20': '0.33408' },
          { '10': '0.29232', '20': '0.41759999999999997' },
          { '10': '0.35496', '20': '0.49067999999999995' },
          { '10': '0.43848', '20': '0.5428799999999999' },
          { '10': '0.5428799999999999', '20': '0.64728' },
          { '10': '0.6368399999999999', '20': '0.7203599999999999' },
          { '10': '0.70992', '20': '0.7934399999999999' },
          { '10': '0.81432', '20': '0.8873999999999999' },
          { '10': '0.92916', '20': '0.9917999999999998' },
          { '10': '1.044', '20': '1.1170799999999999' },
          { '10': '1.12752', '20': '1.2110399999999997' },
          { '10': '1.2110399999999997', '20': '1.31544' },
          { '10': '1.31544', '20': '1.43028' },
          { '10': '1.43028', '20': '1.5451199999999998' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
          { '10': '0', '20': '0' },
        ],
      },
    },
  },
};

_ProductWaiverPremiums.MMDirectTerm = _ProductWaiverPremiums.CASTerm;

export const ProductWaiverPremiums = _ProductWaiverPremiums;
